import { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { inject } from 'mobx-react';

//components
import withLocalization from '~/hoc/withLocalization';
import withRemoveDialog from '~/hoc/withRemoveDialog';
import applicationRouter from '~/hoc/applicationRouter';

//assets
import CloseModalIcon from '../../../assets/img/CloseApproveModalIcon.svg';

import { Intersection } from './intersectionBody.js'
import {
    TimesheetAdjustmentByAbsence, TimesheetAdjustmentByTimesheet,
    TimebankOvertime, MandatoryOvertimeFlexitime, AdminPmComment, ConvertedOvertimeConflict, ResetAutoApprovedLog,
    ApprovedWeeklyOvertime, OvertimeComment, AdditionalPaymentEntry
} from './timelogsModalBody.js'
import { AbsenceAdjustmentByTimesheet, CancelAbsenceVacation, SystemTimesheetAndAbsenceIntersection, AutoTimesheetOnLeaveRemoval, MedicalLeaveMassStatus } from './absenceBody.js'
import { OverlappingRecurringShiftsPlan } from './recurringShiftBody.js'

class UserPromptModal extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { t, source, header, showModal, sourceInfo, actionMethods, actions, commonStore } = this.props;
        const userPromptModal = { source, header, showModal, sourceInfo, actionMethods, actions };
        const dateTimeRules = commonStore.getDateTimeRules();

        const renderBody = () => {
            switch (userPromptModal.source) {
                case "intersection":
                    return <Intersection userPromptModal={userPromptModal} t={t} dateTimeRules={dateTimeRules} commonStore={commonStore} />;
                case "timesheetAdjustmentByAbsence":
                    return <TimesheetAdjustmentByAbsence userPromptModal={userPromptModal} t={t} dateTimeRules={dateTimeRules} />;
                case "timesheetAdjustmentByTimesheet":
                    return <TimesheetAdjustmentByTimesheet userPromptModal={userPromptModal} t={t} dateTimeRules={dateTimeRules} />;
                case "timebankOvertime":
                    return <TimebankOvertime userPromptModal={userPromptModal} t={t} dateTimeRules={dateTimeRules} />;
                case "mandatoryOvertimeFlexitime":
                    return <MandatoryOvertimeFlexitime userPromptModal={userPromptModal} t={t} dateTimeRules={dateTimeRules} />;
                case "adminPmComment":
                    return <AdminPmComment userPromptModal={userPromptModal} t={t} dateTimeRules={dateTimeRules} />;
                case "absenceAdjustmentByTimesheet":
                    return <AbsenceAdjustmentByTimesheet userPromptModal={userPromptModal} t={t} dateTimeRules={dateTimeRules} />;
                case "cancelAbsenceVacation":
                    return <CancelAbsenceVacation userPromptModal={userPromptModal} t={t} dateTimeRules={dateTimeRules} />;
                case "convertedOvertimeConflict":
                    return <ConvertedOvertimeConflict userPromptModal={userPromptModal} t={t} />;
                case "systemTimesheetAndAbsenceIntersection":
                    return <SystemTimesheetAndAbsenceIntersection userPromptModal={userPromptModal} t={t} dateTimeRules={dateTimeRules} />;
                case "resetAutoApprovedLog":
                    return <ResetAutoApprovedLog userPromptModal={userPromptModal} t={t} dateTimeRules={dateTimeRules} />;
                case "autoTimesheetOnLeaveRemoval":
                    return <AutoTimesheetOnLeaveRemoval userPromptModal={userPromptModal} t={t} />;
                case "overtimeComment":
                    return <OvertimeComment userPromptModal={userPromptModal} t={t} dateTimeRules={dateTimeRules} />;
                case "approvedWeeklyOvertime":
                    return <ApprovedWeeklyOvertime userPromptModal={userPromptModal} t={t} dateTimeRules={dateTimeRules} />;
                case "medicalLeaveMassStatus":
                    return <MedicalLeaveMassStatus userPromptModal={userPromptModal} t={t} dateTimeRules={dateTimeRules} />;
                case "additionalPaymentEntry":
                    return <AdditionalPaymentEntry userPromptModal={userPromptModal} t={t} />;
                case "overlappingRecurringShiftsPlan":
                    return <OverlappingRecurringShiftsPlan userPromptModal={userPromptModal} t={t} dateTimeRules={dateTimeRules} />;
                default:
                    return null;
            }
        };

        return (
            <div>
                <Modal
                    backdrop="static"
                    show={userPromptModal.showModal}
                    className="stacked-modal-1070-zindex"
                    backdropClassName="stacked-modal-backdrop-1070-zindex"
                    onHide={() => this.setState({ userPromptModal: { ...userPromptModal, showModal: false } })}>
                    <Modal.Header>
                        <Modal.Title className="w-100 text-center m-0">{t(userPromptModal.header)}</Modal.Title>
                        {
                            userPromptModal.source !== "mandatoryOvertimeFlexitime" &&
                            <img
                                src={CloseModalIcon}
                                alt='closeIcon'
                                className="cursor-pointer"
                                onClick={userPromptModal.actionMethods.handleCloseUserPromptModal}
                            />
                        }
                    </Modal.Header>
                    <Modal.Body>
                        {renderBody()}
                    </Modal.Body>
                </Modal>
            </div >
        );
    }
}

export default inject('commonStore', 'clientStore')(applicationRouter(withLocalization(withRemoveDialog(UserPromptModal))));
